import { Component, Input, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { WsService } from '../../utils/network/ws.service';
import { TranslateModule, TranslateService } from 'ng2-translate/ng2-translate';
import { UserTypeManagerService, UserType } from '../services/usertype/user-type-manager.service';
import { MediaManagerService } from '../services/media/media-manager.service';
import { LayoutManagerService } from '../services/layout/layout-manager.service';
import { PermissionsManagerService } from '../services/permissions/permissions-manager.service';
import { RoomManagerService } from '../services/room/room-manager.service';
@Component({
  selector: "dskl-peer",
  templateUrl: 'peer.component.html',
  styleUrls: ['peers.style.css']
})
export class PeerComponent {
  @Input() peer: any = { media: "none" }
  @Input() layout;
  // @ViewChild('video') private peerVideo;
  private snapshotCanvas: HTMLCanvasElement;
  private snapshotCanvasContext: CanvasRenderingContext2D;
  private snapshotInterval;
  public isSnapshotLayout = false;
  public currentSnapshot;

  constructor(private permissionsManager: PermissionsManagerService, private mediaManager: MediaManagerService, 
  private translate: TranslateService, private userTypeService: UserTypeManagerService, public layoutManager: LayoutManagerService, private roomManager: RoomManagerService) { }
  useTools(peer) {
    peer.canUseTools = !peer.canUseTools;
    this.permissionsManager.sendUseTools(peer.who, peer.canUseTools)
  }
  clickOnRaisedHand(peer) {
    if (this.canSeeControls()||peer.me) {
      this.roomManager.raiseHand(peer.who, !peer.raised);
    }
  }

getRaisedColor(of){
   if (of)return 'orange'
  else return 'gray'
}

  resize(peer) {
    this.layoutManager.sendResize(peer.who);
  }
  getName(peer){
    return this.canSeeControls()?(peer.name?peer.name.substring(0,6):""): peer.name;
  }
  getTalkingColor() { return "black"; }//this.layoutManager.getCurrentColor();}
  peerHasVideo(peer) {
    //console.log("Will check if peer has media ", peer);
    if (!peer.media && !this.isVideoLayout()) return false;
    switch (peer.media) {
      case "audio":
      case "none":

        return false;
      default: return true;
    }
  }
  isVideoLayout() {
    return this.layoutManager.isVideosWb();
  }
  canSeeControls() {
    return this.userTypeService.getType() == UserType.TEACHER;
  }
  kick(peer) {
    //   this.wsService.send("kick", { who: peer.user_hash });
    this.roomManager.kick(peer.who);
  }
  getAudioIcon() {
    switch (this.peer.media) {
      case "audio-snapshots":
      case "none": return 'glyphicon-volume-up';
      case "audio":
      
      default: return 'glyphicon-volume-off';
    }
  }
  tumbClicked() {
    this.layoutManager.tumbClicked();
  }
  getSnapshotColor(){
     switch (this.peer.media) {
      case "audio-snapshots": return '#5cb85c';
      // case "audio":
      default:
        return '';
    }
  }
  getAudioColor() {
    switch (this.peer.media) {
      case "audio-snapshots":
      case "none": return '';
      // case "audio":
      default:
        return '#5cb85c';
    }
  }
 
  getAudioText() {
    let value;
    switch (this.peer.media) {
      case "audio-snapshots":
      case "none": this.translate.get('PEER_TOOLTIP.PLAY_AUDIO').subscribe((res: string) => { value = res; }); return value;
      case "audio":
      
        this.translate.get('PEER_TOOLTIP.STOP_AUDIO').subscribe((res: string) => { value = res; }); return value;
      default: this.translate.get('PEER_TOOLTIP.STOP_AUDIO_AND_VIDEO').subscribe((res: string) => { value = res; }); return value;
    }
  }

  getVideoIcon() {
    switch (this.peer.media) {
      case "none":
      case "audio":
      case "audio-snapshots":
        return 'glyphicon-eye-open';
      default: return 'glyphicon-eye-close';
    }
  }

  getVideoColor() {
    switch (this.peer.media) {
      case "none":
      case "audio-snapshots":
      case "audio": return null;
      default: return '#5cb85c';
    }
  }
  getVideoText() {
    let value;
    switch (this.peer.media) {
      case "none": this.translate.get('PEER_TOOLTIP.PLAY_AUDIO_AND_VIDEO').subscribe((res: string) => { value = res; }); return value;
      case "audio-snapshots":
      case "audio": this.translate.get('PEER_TOOLTIP.PLAY_VIDEO').subscribe((res: string) => { value = res; }); return value;
      default: this.translate.get('PEER_TOOLTIP.STOP_VIDEO').subscribe((res: string) => { value = res; }); return value;

    }
  }
  private updatePeer(media) {
    this.mediaManager.changeMedia(this.peer.who, media);
    //this.wsService.send("update-peer", { media: media, to: this.peer.user_hash });
  }
  onSnapshot(){
     var media;
    switch (this.peer.media) {
     
      case "audio-snapshots":media = "none"; break;
      default: media="audio-snapshots"; break;
    }
    this.updatePeer(media);
  }
  onAudio() {
    var media;
    switch (this.peer.media) {
      case "none": media = "audio"; break;
      case "audio":
      case "audio-snapshots":
      default: media = "none"; break;
    }
    this.updatePeer(media);
  }
  onVideo() {
    var media;
    switch (this.peer.media) {
      case "none":
      case "audio":
      case "audio-snapshots":
        media = "both"; break;
      default: media = "audio"; break;
    }
    this.updatePeer(media);
  }


  onSelected(e, i, peer) {
    console.log("Selected " + i, peer)
    switch (i) {
      case 0: this.onAudio(); break;
      case 1: this.onVideo(); break;
      case 3: this.kick(peer); break;
    }
    console.log("Selected " + i, e);
  }
}



// WEBPACK FOOTER //
// /app/src/app/wb/peers/peer.component.ts